module.exports = __webpack_public_path__ + "img/ja_JP.0b64b56.jpg";